import { STORAGE_PREFIX as prefix } from './redux';

export const getDialog = state => state[prefix];
